import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { TALLY_FORM_ID } from "@/lib/content";

if (TALLY_FORM_ID) {
  const loadContactWidget = () => {
    const script = document.createElement("script");
    script.src = "https://tally.so/widgets/embed.js";
    script.async = true;
    document.head.appendChild(script);
  };
  // Keep the initial image and font requests ahead of the optional popup SDK.
  if (document.readyState === "complete") loadContactWidget();
  else window.addEventListener("load", loadContactWidget, { once: true });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
